import type { ChangelogEntry } from "../types";

/** Ny lokasjon fra mobil (VIB-2947). */
export const LOKASJONER_FRA_MOBIL_2026_10: ChangelogEntry = {
  id: "2026-10-25-lokasjoner-fra-mobil",
  date: "2026-10-25",
  title: "Legg inn lokasjoner fra mobilen",
  summary: "På mobilen setter «Bruk min posisjon» pinnen der du står, og bildene tas rett fra kameraet i skjemaet.",
  sections: [
    {
      heading: "Lokasjoner",
      minRole: "user",
      items: [
        {
          title: "Bruk min posisjon",
          kind: "nytt",
          featureFlag: "feature_locations",
          body: "Telefonens posisjon blir pinnen. Nærmeste adresse og kommune hentes fra Kartverket, og navnet foreslås fra adressen.",
        },
        {
          title: "Bilder rett fra kameraet",
          kind: "nytt",
          featureFlag: "feature_locations",
          body: "«Ta bilder» og «Velg fra galleri» i skjemaet. Bildene lastes opp når du lagrer, med fremdrift per bilde.",
        },
        {
          title: "Skjemaet i full skjerm",
          kind: "forbedret",
          featureFlag: "feature_locations",
          body: "Bare navn og posisjon øverst. Resten ligger under «Mer om stedet (valgfritt)», og «Ny lokasjon» ligger fast nede på skjermen.",
        },
      ],
    },
  ],
};
